import { render, staticRenderFns } from "./BankStatementTransactionChip.vue?vue&type=template&id=d2b656d6&"
import script from "./BankStatementTransactionChip.vue?vue&type=script&lang=js&"
export * from "./BankStatementTransactionChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports